import { Link } from "react-router-dom";
import { MapPin, Briefcase, DollarSign, Shield, Star, BadgeCheck } from "lucide-react";

export default function JobCard({ job, index = 0 }) {
  return (
    <Link
      to={`/jobs/${job.id}`}
      data-testid={`job-card-${job.id}`}
      className={`group block border ${job.featured ? "border-yellow-500/60" : "border-zinc-800"} hover:border-yellow-500 bg-zinc-950/50 p-6 transition-all duration-200 relative`}
      style={{ animation: `fadeUp 0.5s ease ${index * 40}ms both` }}
    >
      {job.featured && (
        <div className="absolute -top-px -left-px bg-yellow-500 text-black text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 flex items-center gap-1">
          <Star size={10} /> Featured
        </div>
      )}
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <div className="text-xs text-yellow-500 font-mono-alt uppercase tracking-wider mb-1">
            {job.industry}
          </div>
          <h3 className="font-display text-2xl uppercase tracking-tight leading-none text-white group-hover:text-yellow-500 transition-colors">
            {job.title}
          </h3>
          <p className="text-zinc-400 text-sm mt-1 flex items-center gap-1">
            {job.employer}
            {job.verified_employer && <BadgeCheck size={14} className="text-yellow-500" title="Verified employer" />}
          </p>
        </div>
        {job.registered_partner && (
          <div className="shrink-0 flex items-center gap-1 border border-yellow-500/40 text-yellow-500 px-2 py-1 text-[10px] uppercase font-bold tracking-wider">
            <Shield size={10} /> Registered
          </div>
        )}
      </div>

      <div className="grid grid-cols-3 gap-3 text-xs text-zinc-400 pt-4 border-t border-zinc-900">
        <div className="flex items-center gap-1"><MapPin size={12} className="text-yellow-500" />{job.city}, {job.state}</div>
        <div className="flex items-center gap-1"><Briefcase size={12} className="text-yellow-500" />{job.type}</div>
        <div className="flex items-center gap-1"><DollarSign size={12} className="text-yellow-500" />${job.wage_min}-${job.wage_max}/hr</div>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Link>
  );
}
